import React from 'react';

import { CaseTypeMetadataEnum } from '@app/types/create-case';

import QueueStats from './queue-stats';
import { useQueueStatsQuery } from '../hooks';

interface QueueStatsContainerProps {
  isServiceQueueOpen: boolean;
  setIsServiceQueueOpen: (isServiceQueueOpen: boolean) => void;
}

interface FormattedQueueStatsData {
  count: number;
  averageWaitTimeInMinutes: string;
}

const QueueStatsContainer: React.FC<QueueStatsContainerProps> = (
  { isServiceQueueOpen, setIsServiceQueueOpen },
) => {
  const { data } = useQueueStatsQuery({
    caseTypeIds: [CaseTypeMetadataEnum.SERVICE],
  });

  const formattedData: FormattedQueueStatsData = {
    count: data?.count ?? 0,
    averageWaitTimeInMinutes: data?.averageWaitTime ? (data.averageWaitTime / 60000).toFixed(2) : '0.00',
  };

  return (
    <QueueStats
      isServiceQueueOpen={isServiceQueueOpen}
      setIsServiceQueueOpen={setIsServiceQueueOpen}
      data={formattedData}
    />
  );
};

export default QueueStatsContainer;
